import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserRole } from 'src/app/shared/models/users/user';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TimesheetGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const role = this.authService.user.role;
        if (role == UserRole.ADMIN || role == UserRole.LAWYER || role == UserRole.ACCOUNTING) {
            return true;
        } else {
            this.router.navigate(['/']);
            return false;
        }
    }
  
}
